<h1 mat-dialog-title class="text-center" *ngIf="data.titulo"><mat-icon style="color: #003057;">info</mat-icon>&nbsp;{{data.titulo}}</h1>
<div mat-dialog-content>
  <p class="text-center" style="font-size: 1.5rem;">{{data.message}}</p>
  <p style="color: #721c24; font-size: 1.1rem;">{{data.submessage}}</p>
</div>
<div mat-dialog-actions class="d-flex justify-content-center">
  <button mat-raised-button (click)="closeConfirmDialog()" class="text-danger">{{data.labelCancel}}</button>
  <button mat-raised-button (click)="confirmDialog()" cdkFocusInitial color="primary"  >{{data.labelOk}}</button>
</div>
